import { z } from 'zod';
import { env } from '@/core/config/env';
import { ApiError } from '@/core/api/errors';

/** The Apps Script answers `{ success, message?, ticketNumber? }`. */
const responseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  ticketNumber: z.union([z.string(), z.number()]).optional().transform((v) => (v == null ? undefined : String(v))),
});

async function postToSheet(payload: Record<string, unknown>) {
  let text: string;
  try {
    // No custom headers: Apps Script web-apps reject CORS pre-flights, so this stays a "simple" request.
    const res = await fetch(env.supportScriptUrl, { method: 'POST', body: JSON.stringify(payload), redirect: 'follow' });
    text = await res.text();
  } catch {
    throw new ApiError('اتصال به اینترنت برقرار نیست');
  }
  let parsed: z.infer<typeof responseSchema>;
  try {
    parsed = responseSchema.parse(JSON.parse(text));
  } catch {
    throw new ApiError('پاسخ معتبری از سرور دریافت نشد');
  }
  if (!parsed.success) throw new ApiError(parsed.message || 'ثبت اطلاعات با مشکل مواجه شد');
  return parsed;
}

export interface ComplaintForm { loadCode: string; name: string; mobile: string; category: string; description: string }
export interface CareerForm { name: string; mobile: string; resumeLink: string; position?: string }

export const submitComplaint = (form: ComplaintForm) => postToSheet({ type: 'complaint', ...form });
export const submitContactRequest = (form: CareerForm | Record<string, string>) => postToSheet({ type: 'contact', ...form });
